import { To, useLocation } from 'react-router-dom';

import resolveTo from './resolveToWithSearch.js';
/**
 * resolveTo with and current location.search by context
 */
export const useResolveToWithSearch = () => {
  const location = useLocation();

  return (to: To, keepSearchParams = false) => {
    if (keepSearchParams) {
      return resolveTo(to, location.search);
    }
    return resolveTo(to);
  };
};

export default useResolveToWithSearch;
